import Documentation from "components/Documentation";

const DocumentationViewModePage = () => {
  return (
    <div className="w-screen h-screen h-screen-dvh flex flex-col">
      <Documentation isViewMode={true} />
    </div>
  );
};

export default DocumentationViewModePage;
